/* eslint-disable import/no-unresolved,import/first */
import * as all from '@jojocoders/jojonomic-ui';
import { layout } from 'vue-extend-layout';
import Vue from 'vue';
import stores from './stores/index';
import Storage from 'vue-ls';
import router from './router';
import VueQuillEditor from 'vue-quill-editor';

Vue.use(VueQuillEditor);

// axios global
window.axios = require('axios');

// vendor
const keys = Object.keys(all);
keys.forEach((data) => {
  if (Array.isArray(all[data])) {
    Vue.use(...all[data]);
  } else {
    Vue.use(all[data]);
  }
});

Vue.use(Storage);

// eslint-disable-next-line
import 'quill/dist/quill.core.css';
// eslint-disable-next-line
import 'quill/dist/quill.snow.css';
// eslint-disable-next-line
import 'quill/dist/quill.bubble.css';
// import this project scss
import './sass/main.scss';

// register global component here
// ex: Vue.component('header', Header)

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store: stores,
  ...layout,
});



// WEBPACK FOOTER //
// ./src/main.js